import { render, staticRenderFns } from "./ArticleHeaderTitle.vue?vue&type=template&id=50960a3c&scoped=true"
import script from "./ArticleHeaderTitle.vue?vue&type=script&lang=js"
export * from "./ArticleHeaderTitle.vue?vue&type=script&lang=js"
import style0 from "./ArticleHeaderTitle.vue?vue&type=style&index=0&id=50960a3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50960a3c",
  null
  
)

export default component.exports